import AbstractHeader from './AbstractHeader'


export default class DesktopHeader extends AbstractHeader {
  constructor() {
    super($('#shead-dt'), 'shead-dt')

    this.searchButton = this.find('searchButton')

    this.reactToScreenSizeAndScroll()
    $(window).on('load resize scroll orientationchange', this.reactToScreenSizeAndScroll.bind(this))
    this.bindControls()
    this.search.on('searchSuccess', this.reactToScreenSizeAndScroll.bind(this))
    this.initSubmenus();
  }

  initSubmenus() {
    $('.shead-dt .sub-menu a').on('click', function(e) {
        if ($(this).parent().hasClass('menu-item-has-children')) {
            e.preventDefault();
            $(this).next().slideToggle();
            $(this).toggleClass('is-active');
        }
    });
  }

  limitSearchHeight() {
    this.search.resultsWrapper.css({
      height: (window.innerHeight - (this.search.container.offset().top + this.search.head.height()) - 100) + 'px'
    })
  }

  hideMenus() {
    this.find('menu').removeClass('s-frozen')
    this.searchButton.add(this.search.container).removeClass('s-open')
  }

  bindControls() {
    super.bindControls()
    this.find('regionPickerButton').on('click', () => {
      $(document.body).trigger('regionPicker/show')
    })
    this.searchButton.on('click', () => {
      if (this.searchButton.hasClass('s-open')) {
        this.searchButton.add(this.search.container).removeClass('s-open')
        this.search.clear()
      } else {
        this.searchButton.add(this.search.container).addClass('s-open')
        this.search.input.trigger('focus')
      }
    })
  }

  reactToScreenSizeAndScroll() {
    if (this.inactive) return
    this.limitSearchHeight()
  }
}
